var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _vm.isSearchBarVisible
      ? _c("div", [
          _c("div", { staticClass: "spacer-15" }),
          _c(
            "div",
            {
              ref: "search",
              staticClass: "stickySearch",
              class: { empty: !_vm.showSearchResults },
            },
            [
              _c(
                "v-container",
                {
                  staticClass: "vcontainer",
                  class: { empty: !_vm.showSearchResults },
                  attrs: { "grid-list-md": "" },
                },
                [
                  _c("div", { staticClass: "quickBar" }, [
                    _c("div", { staticClass: "c1" }, [
                      _c(
                        "div",
                        { staticClass: "prelative" },
                        [
                          _c("v-text-field", {
                            staticClass: "dropdownBorder mb-0",
                            attrs: {
                              value: _vm.searchPhrase,
                              "prepend-inner-icon": "mdi-magnify",
                              placeholder: "Suche",
                              "hide-details": "",
                              dense: "",
                              outlined: "",
                              clearable: "",
                            },
                            on: {
                              input: _vm.updateSearchPhrase,
                              focus: function ($event) {
                                _vm.searchInFocus = true
                              },
                              blur: function ($event) {
                                _vm.searchInFocus = false
                              },
                            },
                          }),
                          !_vm.searchInFocus && _vm.searchPhrase.length > 0
                            ? _c(
                                "div",
                                { staticClass: "absClear dense" },
                                [
                                  _c(
                                    "v-icon",
                                    {
                                      staticClass: "myBlack",
                                      on: {
                                        "&click": function ($event) {
                                          $event.stopPropagation()
                                          _vm.searchPhrase = ""
                                        },
                                      },
                                    },
                                    [_vm._v("mdi-close ")]
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                    ]),
                    !_vm.$store.getters.isKiosk
                      ? _c(
                          "div",
                          { staticClass: "c2 flexAlignCenter" },
                          [
                            _c(
                              "v-btn",
                              {
                                staticClass: "btnIcon",
                                attrs: { icon: "" },
                                nativeOn: {
                                  "&click": function ($event) {
                                    return _vm.$ebus.$emit("goto", {
                                      name: "Favoriten",
                                    })
                                  },
                                },
                              },
                              [
                                _c(
                                  "v-icon",
                                  {
                                    staticClass: "myWhite",
                                    attrs: { small: "" },
                                  },
                                  [_vm._v("mdi-heart")]
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm.$store.state.showSearchFilter
                      ? _c(
                          "div",
                          { staticClass: "c2 flexAlignCenter" },
                          [
                            _c(
                              "v-btn",
                              {
                                staticClass: "btnIcon",
                                class: {
                                  "btn-danger":
                                    _vm.$store.getters.allergenesFilter.length >
                                    0,
                                },
                                attrs: { icon: "" },
                                nativeOn: {
                                  "&click": function ($event) {
                                    return _vm.$ebus.$emit(
                                      "triggerFilterDialog"
                                    )
                                  },
                                },
                              },
                              [
                                _vm.$store.getters.allergenesFilter.length > 0
                                  ? _c(
                                      "div",
                                      { staticClass: "prelative" },
                                      [
                                        _c(
                                          "v-icon",
                                          {
                                            staticClass: "myWhite",
                                            attrs: { small: "" },
                                          },
                                          [_vm._v("mdi-filter")]
                                        ),
                                        _c(
                                          "v-icon",
                                          {
                                            staticClass: "myWhite absCheck",
                                            attrs: { "x-small": "" },
                                          },
                                          [_vm._v("mdi-check")]
                                        ),
                                      ],
                                      1
                                    )
                                  : _c(
                                      "v-icon",
                                      {
                                        staticClass: "myWhite",
                                        attrs: { small: "" },
                                      },
                                      [_vm._v("mdi-filter")]
                                    ),
                              ],
                              1
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                  ]),
                ]
              ),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.showSearchResults,
                      expression: "showSearchResults",
                    },
                  ],
                  staticClass: "absSearchResult",
                },
                [
                  _c(
                    "v-container",
                    { attrs: { "grid-list-lg": "" } },
                    [
                      _c(
                        "v-layout",
                        { attrs: { row: "", wrap: "" } },
                        _vm._l(_vm.filteredCategories, function (cat, index) {
                          return _c(
                            "v-flex",
                            { attrs: { xs12: "", sm6: "", lg4: "" } },
                            [
                              _c("CategoryCard", {
                                staticClass: "pointer",
                                attrs: { category: cat },
                                nativeOn: {
                                  "&click": function ($event) {
                                    return _vm.gotoCategory(cat)
                                  },
                                },
                              }),
                            ],
                            1
                          )
                        }),
                        1
                      ),
                      _c(
                        "v-layout",
                        {
                          staticClass: "withBorderLine",
                          attrs: { row: "", wrap: "" },
                        },
                        [
                          _vm._l(_vm.filteredFoodItems, function (item, index) {
                            return _c(
                              "v-flex",
                              { attrs: { xs12: "", sm6: "", lg4: "" } },
                              [
                                _c(
                                  "v-list",
                                  { staticClass: "itemsList" },
                                  [
                                    _c("ItemsRow", {
                                      key: item.id,
                                      attrs: {
                                        id: "sfrow" + index,
                                        fordrinks: false,
                                        expanded:
                                          _vm.showItemExtras &&
                                          _vm.currentItem.id === item.id,
                                        isSection: !!item.section,
                                        item: item,
                                      },
                                      on: {
                                        close: function ($event) {
                                          _vm.showItemExtras = false
                                          _vm.currentItem = { id: "" }
                                        },
                                        expandExtrasForItem: function ($event) {
                                          return _vm.expandExtras(item, index)
                                        },
                                      },
                                      nativeOn: {
                                        "&click": function ($event) {
                                          return _vm.expandExtras(item, index)
                                        },
                                      },
                                    }),
                                    _c(
                                      "div",
                                      {
                                        staticClass: "prelative",
                                        staticStyle: { "padding-top": "6px" },
                                        on: {
                                          "&click": function ($event) {
                                            $event.stopPropagation()
                                            return _vm.noOp.apply(
                                              null,
                                              arguments
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _vm.showItemExtras &&
                                        _vm.currentItem.id === item.id
                                          ? _c("ItemExtrasOverlay", {
                                              attrs: {
                                                fordrinks: false,
                                                itemId: _vm.currentItem.id,
                                              },
                                              on: {
                                                wasAdded: function ($event) {},
                                              },
                                            })
                                          : _vm._e(),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            )
                          }),
                          _vm._l(
                            _vm.filteredDrinkItems,
                            function (item, index) {
                              return _c(
                                "v-flex",
                                { attrs: { xs12: "", sm8: "", lg4: "" } },
                                [
                                  _c(
                                    "v-list",
                                    { staticClass: "itemsList" },
                                    [
                                      _c("ItemsRow", {
                                        key: item.id,
                                        attrs: {
                                          id: "sdrow" + index,
                                          fordrinks: true,
                                          expanded:
                                            _vm.showItemExtras &&
                                            _vm.currentItem.id === item.id,
                                          isSection: !!item.section,
                                          item: item,
                                        },
                                        on: {
                                          close: function ($event) {
                                            _vm.showItemExtras = false
                                            _vm.currentItem = { id: "" }
                                          },
                                          expandExtrasForItem: function (
                                            $event
                                          ) {
                                            return _vm.expandExtras(item, index)
                                          },
                                        },
                                        nativeOn: {
                                          "&click": function ($event) {
                                            return _vm.expandExtras(item, index)
                                          },
                                        },
                                      }),
                                      _c(
                                        "div",
                                        {
                                          staticClass: "prelative",
                                          staticStyle: { "padding-top": "6px" },
                                          on: {
                                            "&click": function ($event) {
                                              $event.stopPropagation()
                                              return _vm.noOp.apply(
                                                null,
                                                arguments
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _vm.showItemExtras &&
                                          _vm.currentItem.id === item.id
                                            ? _c("ItemExtrasOverlay", {
                                                attrs: {
                                                  fordrinks: true,
                                                  itemId: _vm.currentItem.id,
                                                },
                                                on: {
                                                  wasAdded: function (
                                                    $event
                                                  ) {},
                                                },
                                              })
                                            : _vm._e(),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              )
                            }
                          ),
                        ],
                        2
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }